import serialize from "json-form-data";
import { param } from "@/utils/url/param";
import {addAuthKey} from '@/helpers/addAuthKeyToUrl';

const api_url = "/index.php";

export default {
    namespaced: true,

    store: {},

    mutations: {},

    actions: {
        async getColumnsList(ctx, params) {
            let searchParams = {
                auth_key: ctx.rootState.authToken,
                r: "api/timesheet/columns"
            };

            if (params && params.section) {
                searchParams.section = params.section;
            }

            searchParams = param(searchParams);

            const res = await fetch(`${api_url}/?${searchParams}`);
            const json = await res.json();
            return json;
        },

        async getUserColumnsList(ctx, params) {
            let searchParams = {
                auth_key: ctx.rootState.authToken,
                r: "api/timesheet/user-columns",
                user_id: ctx.rootState.userId
            };

            if (params && params.section) {
                searchParams.section = params.section;
            }

            searchParams = param(searchParams);

            const res = await fetch(`${api_url}/?${searchParams}`);
            const json = await res.json();
            return json;
        },

        async saveUserColumnsList(ctx, params) {
            let searchParams = {
                auth_key: ctx.rootState.authToken,
                user_id: ctx.rootState.userId,
                r: "api/timesheet/save-user-columns"
            };

            if (params.section) {
                searchParams.section = params.section;
            }

            searchParams = param(searchParams);

            const body = serialize({
                columns: JSON.stringify(params.columns),
                user_id: ctx.rootState.userId
            });

            const res = await fetch(`${api_url}/?${searchParams}`, {
                method: "POST",
                body
            });
            const json = await res.json();
            return json;
        },

        // получение списка табелей (с фильтрами и пагинацией)
        async getList(ctx, params) {
            let searchParams = {
                auth_key: ctx.rootState.authToken,
                r: "api/timesheet/index",
                sort: `${params.desc ? "-" : ""}${params.sortBy}`,
                page: params.page,
                ...params.tableFilters
            };

            if (params.periodFrom && params.periodTo) {
                searchParams.period_from = params.periodFrom;
                searchParams.period_to = params.periodTo;
            }

            if (params.filials) {
                searchParams.filial_filter_ids = params.filials;
                searchParams.filial_filter_ids_except = params.filialsExcept
                    ? 1
                    : 0;
            }

            searchParams = param(searchParams);

            const res = await fetch(`${api_url}/?${searchParams}`);
            const json = await res.json();

            return {
                items: json,
                totalCount: res.headers.get("X-Pagination-Total-Count")
            };
        },

        // получение списка должностей (с учетом порядка)
        async getPositions(ctx) {
            const token = ctx.rootState.authToken
            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/timesheet/post-list`, token)
            );
            const json = await res.json();
            return json;
        },

        // получение дефолтных смен
        async getShifts(ctx) {
            const token = ctx.rootState.authToken
            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/timesheet/shift-interval-list`, token)
            );
            const json = await res.json();

            return json;
        },

        // получение данных
        async getData(ctx, params) {
            let searchParams = {
                auth_key: ctx.rootState.authToken,
                r: "api/timesheet/view",
                ...params
            };

            searchParams = param(searchParams);
            const res = await fetch(`${api_url}/?${searchParams}`);
            const json = await res.json();
            return json;
        },

        async getCalculation(ctx, params) {
            let searchParams = {
                auth_key: ctx.rootState.authToken,
                r: "api/timesheet/calculated-days",
                ...params
            };

            searchParams = param(searchParams);
            const res = await fetch(`${api_url}/?${searchParams}`);
            const json = await res.json();
            return json;
        },

        async saveTimesheet(ctx, params) {
            const searchParams = param({
                auth_key: ctx.rootState.authToken,
                r: params.id ? "api/timesheet/update" : "api/timesheet/create",
                period: params.period,
                filial_id: params.filial_id
            });

            const body = JSON.stringify({
                workers: params.workers,
                days: params.days
            });

            const res = await fetch(`${api_url}/?${searchParams}`, {
                method: "POST",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                body
            });

            const json = await res.json();
            return json;
        },

        async removeTimesheet(ctx, params) {
            const searchParams = param({
                auth_key: ctx.rootState.authToken,
                r: "api/timesheet/delete",
                id: params.id
            });

            const res = await fetch(`${api_url}/?${searchParams}`, {
                method: "DELETE"
            });

            const json = await res.json();
            return json;
        },

        // типы отпусков (для справочника)
        async getVacationTypes(ctx) {
            const searchParams = param({
                auth_key: ctx.rootState.authToken,
                r: "api/vacation-types/index"
            });

            const res = await fetch(`${api_url}/?${searchParams}`);
            const json = await res.json();

            return json;
        },

        // список сотрудников для должности
        async getWorkersList(ctx, params) {
            let searchParams = {
                auth_key: ctx.rootState.authToken,
                r: "api/timesheet/workers",
                post_code: params.position,
                period: params.period
            };

            if (params.filial) searchParams.filial_id = params.filial;
            //searchParams = param(searchParams);


            if (params.allFilials) searchParams.allFilials = 1;
            searchParams = param(searchParams);

            const res = await fetch(`${api_url}/?${searchParams}`);
            const json = await res.json();

            return json;
        },

        async loadAllFilials(ctx) {
            const token = ctx.rootState.authToken
            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/timesheet/filials`, token)
            );

            const json = await res.json();

            return json.map(post => ({
                value: post.id,
                label: post.name
            }));
        },
    }
};
